export const PAYMENT_MODEL_AD_PLAYS = 'ad_plays';
export const PAYMENT_MODEL_CPM = 'cpm';
export const PAYMENT_MODEL_CPV = 'cpv';
export const PAYMENT_MODEL_GUARANTEED = 'guaranteed';
